import { useEffect } from 'react';
import LabelsDataTable from './LabelsDataTable/LabelsDataTable';

function Labels() {

  // #region templates

  const viewTemplate = (
    <>
      <article>
        <section>
          <h1>
            Etiquetas
          </h1>
        </section>
        <section>
          <LabelsDataTable />
        </section>
      </article>
    </>
  );

  // #endregion

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }, []);

  return (
    <>
      {viewTemplate}
    </>
  );
}

export default Labels;